{
  "loading": "Načítání...",
  "loadingMore": "Načítání dalších..."
}
